import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AgGridAngular} from 'ag-grid-angular';
import {
  ParametroConciliacionBancariaService
} from '../../../services/conciliacion-bancaria/parametro-conciliacion-bancaria.service';
import {CobrosAutoserviciosService} from '../../../services/cobrosAutoservicio/cobros-autoservicios.service';
import {ParametrosCobrosAuto} from '../../../models/cobrosAutoservicio/parametrosCobrosAuto';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {CommonFormService} from 'src/app/shared/utils/common-form.service';
import {moduloCobrosAutoservicio} from '../../../diccionarios/cobrosAutoServiciosModulo';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';

@Component({
  selector: 'app-parametros-cobros-autoservicios',
  templateUrl: './parametros-cobros-autoservicios.component.html',
  styleUrls: ['./parametros-cobros-autoservicios.component.css']
})
export class ParametrosCobrosAutoserviciosComponent implements OnInit {

  formulario: FormGroup;
  mostrarFormulario = false;
  textoBuscar = '';

  deshabComProbante = true;
  deshabValor = true;
  deshabTotal = true;

  deshabpoNumDoc = true;
  deshabpoNumRef = true;

  //btnContinuar = buttons.guardar;

  // Componentes del Grid
  @ViewChild('agGrid') agGrid: AgGridAngular;
  textBoton = '';
  rowData: ParametrosCobrosAuto[] = [];
  DAT_MSG: any;
  DAT_BTNS: any;
  DAT_BTNCSS: any;
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  rowSelection: any;
  // Combos
  cmbDelimitador: any[];
  cmbTipoDocumento: any[];
  cmbOptions: any[];
  //diccionario
  cobroAutoModulo: any;
  loading: boolean = false;
  private editableForm = false;

  constructor(private ParametroConciBanca: ParametroConciliacionBancariaService,
              public fb: FormBuilder,
              private _coboros: CobrosAutoserviciosService,
              private _util: UtilsService,
              private commonFormService: CommonFormService) {

    this.cobroAutoModulo = moduloCobrosAutoservicio;

    this.cmbDelimitador = [
      {id: ',', valor: 'Coma(,)'},
      {id: ';', valor: 'Unidades(;)'},
      {id: '\t', valor: 'Tab(---)'}
    ];

    this.cmbTipoDocumento = [
      {id: 'Contable', valor: 'Contable'},
      {id: 'Comercial', valor: 'Comercial'}
    ];

    this.cmbOptions = [
      {id: true, valor: 'Si'},
      {id: false, valor: 'No'}
    ];

    this.formulario = this.fb.group({
      idParametro: [''],
      delimitador: ['', [Validators.required]],
      nombreFormato: ['', [Validators.required, Validators.min(1), Validators.minLength(3), Validators.maxLength(50)]],
      linIniDatos: ['', [Validators.required, Validators.min(1), Validators.minLength(1), Validators.maxLength(3)]],
      tipoDocumento: ['', [Validators.required]],
      poscSigno: ['', [Validators.required, Validators.min(1), Validators.minLength(1), Validators.maxLength(3)]],
      poscValor: ['', [Validators.required, Validators.min(1), Validators.minLength(1), Validators.maxLength(3)]],
      poscReferencia: ['', [Validators.required, Validators.min(1), Validators.minLength(1), Validators.maxLength(3)]],
      poscNumDocumento: ['', [Validators.required, Validators.min(1), Validators.minLength(1), Validators.maxLength(3)]],
      numComprobamPresent: ['', [Validators.required]],
      posColumComproban: ['', [Validators.required]],
      posFilaComproban: ['', [Validators.required]],
      totalPresent: ['', [Validators.required]],
      posColumTot: ['', [Validators.required]],
      posFilaTot: ['', [Validators.required]]
    });
  }

  ngOnInit() {
    this.DAT_BTNS = this.cobroAutoModulo.button.buttonsNombre;
    this.DAT_MSG = this.cobroAutoModulo.mensajes;
    this.DAT_BTNCSS = this.cobroAutoModulo.button.buttonsCss;

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'NOMBRE',
        field: 'nombreFormato',
        sortable: true,
        filter: true,
        // checkboxSelection: true,
        // headerCheckboxSelection: true,
        width: 200
      },
      {
        headerName: 'DOCUMENTO',
        field: 'tipoDocumento',
        sortable: true,
        filter: true
      },
      {
        headerName: 'DELIMITADOR',
        field: 'delimitador',
        sortable: true,
        filter: true
      },
      {
        headerName: 'N° Comprobante',
        //field: 'numComprobamPresent',
        sortable: true,
        filter: true,
        valueGetter(params) {
          return (params.data.numComprobamPresent) ? 'SI' : 'NO'
        },
      },
      {
        headerName: 'Total',
        // field: 'totalPresent',
        sortable: true,
        filter: true,
        valueGetter(params) {
          return (params.data.totalPresent) ? 'SI' : 'NO'
        },
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 120,
        cellRendererParams: {
          onClick: this.abrirFormularioParaEditarHTML.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info//'btn btn-info btn btn-block'
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 120,
        cellRendererParams: {
          onClick: this.eliminarElementoColumna.bind(this),
          label: this.DAT_BTNS.eliminar,//buttons.eliminar,
          colorBoton: this.DAT_BTNCSS.danger//'btn btn-danger btn btn-block'
        }
      }
    ];
    this.rowSelection = 'multiple';
    this.getAll();
  }

  getAll() {
    this._coboros.getAll().subscribe((res: any) => {
      this.rowData = res;
    }, (err) => {
      this.rowData = [];
      console.log(err);
    });
  }

  onGridReady(params) {
    //this.commonFormService.onGridReadyUtil(this, params, this._coboros);
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    // this.getAll();
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  changeNumComprobante(event) {
    let ban = this.formulario.get('numComprobamPresent').value;
    this.deshabComProbante = true;
    if (ban) {
      this.deshabComProbante = false;
    } else {
      this.formulario.get('posColumComproban').setValue(0);
      this.formulario.get('posFilaComproban').setValue(0);
    }
  }

  changeTotal(event) {
    let ban = this.formulario.get('totalPresent').value;
    this.deshabTotal = true;
    if (ban) {
      this.deshabTotal = false;
    } else {
      this.formulario.get('posColumTot').setValue(0);
      this.formulario.get('posFilaTot').setValue(0);
    }
  }

  setValoresCeros() {
    this.formulario.get('numComprobamPresent').setValue(false);
    this.formulario.get('posColumComproban').setValue(0);
    this.formulario.get('posFilaComproban').setValue(0);
    this.formulario.get('totalPresent').setValue(false);
    this.formulario.get('posColumTot').setValue(0);
    this.formulario.get('posFilaTot').setValue(0);
  }

  changeTipoDoc(event) {
    this.setValoresCeros();
    let ban = this.formulario.get('tipoDocumento').value;
    this.deshabpoNumDoc = true;
    this.deshabpoNumRef = true;
    if (ban == 'Contable') {
      this.formulario.get("poscReferencia").clearValidators();
      this.formulario.get("poscReferencia").setValue(0);
      this.deshabpoNumDoc = false;
      this.deshabpoNumRef = true;
    } else if (ban == 'Comercial') {
      this.formulario.get("poscReferencia").setValidators([Validators.required, Validators.min(1), Validators.minLength(1), Validators.maxLength(3)]);
      // this.formulario.get("poscReferencia").setValue('');
      this.deshabpoNumDoc = false;
      this.deshabpoNumRef = false;
    }
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
        return this.editarParametro();
      } else {
        this.guaradarParametros();
      }
    } else {
      this.commonFormService.limpiarYregrear(this);
    }
  }

  devolverObjeto(data): ParametrosCobrosAuto {
    const enviarObjeto = new ParametrosCobrosAuto(data);
    return enviarObjeto;
  }

  guaradarParametros() {
    const data = this.formulario.getRawValue();
    // this._util.confirmarAcyncronico(this, {title: this.DAT_MSG.guardar, text: ``, action: this.DAT_BTNS.guardar}, () => {
    //   return this._coboros.guardarParametros(this.devolverObjeto(data));
    // });
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: '',
        action: this.DAT_BTNS.guardar,
        funcion: this._coboros.guardarParametros(this.devolverObjeto(data))
      }).then((response: any) => {
      this.getAll();
      this.commonFormService.limpiarYregrear(this);
    }).catch((err) => {
      console.log('cayo un errorsito' + err);
    });
  }

  editarParametro() {
    const data = this.formulario.getRawValue();
    // this._util.confirmarAcyncronico(this, {title: this.DAT_MSG.actualizar, text: ``, action: this.DAT_BTNS.editar}, () => {
    //   return this._coboros.actualizarParametros(this.devolverObjeto(data));
    // });
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: '',
        action: this.DAT_BTNS.editar,
        funcion: this._coboros.actualizarParametros(this.devolverObjeto(data))
      }).then((response: any) => {
      this.getAll();
      this.commonFormService.limpiarYregrear(this);
    }).catch((err) => {
      console.log('cayo un errorsito' + err);
    });
  }

  abrirFormularioParaGuardarHTML() {
    this.commonFormService.abrirFormularioParaGuardar(this);
  }

  abrirFormularioParaEditarHTML({rowData}) {
    this.editableForm = true;
    this.textBoton = this.DAT_BTNS.editar;//buttons.editar;
    this.mostrarFormulario = true;
    this.formulario.setValue(rowData);
    this.changeNumComprobante({});
    this.changeTipoDoc({});
    this.changeTotal({});
  }

  eliminarElementoColumna({rowData}) {
    // this._util.confirmarAcyncronico(this, {title: this.DAT_MSG.eliminar, text: ``, action: this.DAT_BTNS.eliminar}, () => {
    //   return this._coboros.eliminarParametros(rowData.idParametro);
    // }, () => {
    //   this.rowData = this.rowData.filter(item => item.idParametro !== rowData.idParametro);
    // });
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.eliminar,
        text: '',
        action: this.DAT_BTNS.eliminar,
        funcion: this._coboros.eliminarParametros(rowData.idParametro)
      }).then((response: any) => {
      this.rowData = this.rowData.filter(item => item.idParametro !== rowData.idParametro);
    }).catch((err) => {
      console.log('cayo un errorsito' + err);
    });

  }

}
